import { Breakpoints } from './GridSizes';

const MediaQueries = {
  xs: `@media screen and (max-width: ${Breakpoints.sm}px)`,
  sm: `@media screen and (max-width: ${Breakpoints.md - 1}px)`,
  smAndUp: `@media screen and (min-width: ${Breakpoints.sm}px)`,
  md: `@media screen and (min-width: ${Breakpoints.md}px) and (max-width: ${
    Breakpoints.lg - 1
  }px)`,
  mdAndUp: `@media screen and (min-width: ${Breakpoints.md}px)`,
  lg: `@media screen and (min-width: ${Breakpoints.lg}px) and (max-width: ${
    Breakpoints.xl - 1
  }px)`,
  lgAndUp: `@media screen and (min-width: ${Breakpoints.lg}px)`,
  xl: `@media screen and (min-width: ${Breakpoints.xl}px)`,
};

export default MediaQueries;
